import {
  Box,
  Heading,
  Flex,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import AvatarMenu from "../components/navbar/avatar-menu";
import SidebarContent from "../components/dashboard/sidebar-content";
import SearchInput from "../components/search";
import axios from "axios";
import { useContext, useState, useEffect } from "react";
import Navbar from "../components/navbar/Navbar";
import { showToast } from "../components/toast-alert";
import SearchContext from "../SearchContext";
import { useTranslation } from "react-i18next";
import CreateItemDrawer from "../components/dashboard/create-drawer";
import RentsList from "../components/dashboard/rents-list";
import CarsList from "../components/dashboard/cars-list";
const backendUrl = process.env.REACT_APP_BACKEND_URL;

function Dashboard() {
  const { t } = useTranslation();
  const toast = useToast();
  const { searchResults } = useContext(SearchContext);
  const [type, setType] = useState("rents");
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    console.log("type", type);
    handleData(type);
  }, [type]);

  const handleData = (type) => {
    console.log("changing type to:", type);
    if (type === "cars") {
      setType("cars");
      console.log("type", type);
    } else if (type === "rents") {
      setType("rents");
      console.log("type", type);
    }
  };

  const handleUpdateItem = (itemId, updatedItem) => {
    const endpoint = `${backendUrl}/api/${type}/${itemId}`;

    axios
      .put(endpoint, updatedItem)
      .then((response) => {
        showToast(toast, `${type} updated successfully!`, "success", "Success");
        console.log(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleDelete = (id) => {
    const endpoint = `${backendUrl}/api/${type}/${id}`;

    axios
      .delete(endpoint)
      .then((response) => {
        showToast(toast, `${type} deleted successfully!`, "success", "Success");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <Navbar
        sidebarContent={<SidebarContent handleData={handleData} />}
        buttons={
          <>
            <SearchInput type={type.toLowerCase()} />
            <AvatarMenu />
          </>
        }
      />
      <Box as="section" minH="100vh">
        <Box
          ml={{
            base: 0,
            md: 60,
          }}
          transition=".3s ease"
        >
          <Box as="main" p={4}>
            <Box rounded="md" h="auto">
              <Box h={"full"} w={"full"} overflowX="auto">
                <Flex align="center" justify="space-between" pb={5}>
                  {type === "cars" && <CreateItemDrawer dataType={type} />}
                </Flex>
                {type === "rents" && (
                  <RentsList
                    handleUpdateItem={handleUpdateItem}
                    handleDelete={handleDelete}
                  />
                )}
                {type === "cars" && (
                  <CarsList
                    handleUpdateItem={handleUpdateItem}
                    handleDelete={handleDelete}
                  />
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      {isOpen && (
        <Drawer isOpen={isOpen} placement="left" onClose={onClose} size="xs">
          <DrawerOverlay />
          <DrawerContent>
            <SidebarContent
              handleData={handleData}
              w="full"
              borderRight="none"
            />
          </DrawerContent>
        </Drawer>
      )}
    </>
  );
}

export default Dashboard;
